export var SHOW_RECENT_CUSTOMERS_PANEL = 'SHOW_RECENT_CUSTOMERS_PANEL';
export var HIDE_RECENT_CUSTOMERS_PANEL = 'HIDE_RECENT_CUSTOMERS_PANEL';
export var showRecentCustomersPanel = function showRecentCustomersPanel() {
  return {
    type: SHOW_RECENT_CUSTOMERS_PANEL
  };
};
export var hideRecentCustomersPanel = function hideRecentCustomersPanel() {
  return {
    type: HIDE_RECENT_CUSTOMERS_PANEL
  };
};